var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from "vue-property-decorator";
import axios from "axios";
class Workflow {
    id = undefined;
    name = "";
    description = "";
    control = false;
    date;
    time;
    work_type = "";
}
class assignment {
    id = undefined;
    material = "";
    thickness = "";
    format = "";
    quantity = "";
}
class job {
    article = "";
    customer = "";
    date = "";
    index = "";
    note = "";
    quantity_per_piece = "";
    time = "";
    order_nr = "";
    final_control = false;
    created_at = new Date().toISOString().split("T")[0] + ' ' + new Date().toISOString().split("T")[1];
}
let CreateJob = class CreateJob extends Vue {
    diaWork = false;
    e1 = 1;
    job = new job();
    workstep = {};
    assignments = [];
    assignment = new assignment();
    material = [];
    thickness = [];
    format = [];
    worktype = [];
    worklogs = [];
    workflow = new Workflow();
    count = 0;
    dia = false;
    text = '';
    snackbar = false;
    timeout = 5000;
    color = "#F44336";
    customer = [];
    headers = [
        { text: 'Format', value: 'format' },
        { text: 'Material', value: 'material' },
        { text: 'Dicke', value: 'thickness' },
        { text: 'Anzahl', value: 'quantity' },
        { text: 'Aktionen', value: 'actions' },
    ];
    worklogheader = [
        { text: 'Ausführender', value: 'name' },
        { text: 'Kontrolle', value: 'control' },
        { text: 'Arbeitschritt', value: 'work_type' },
        { text: 'Beschreibung', value: 'description' },
        { text: 'Datum', value: 'date' },
        // {text: 'Zeit', value: 'time'},
        { text: 'Aktionen', value: 'actions' },
    ];
    create() {
        axios.post('/api/jobs', { job: this.job, assignments: this.assignments, worklogs: this.worklogs }).then((response) => {
            if (response.status == 201) {
                this.printPDF(response.data.data.id);
                setTimeout(() => {
                    this.$router.push('/job');
                }, 2500);
            }
        }).catch((error) => {
            Object["values"](error.response.data.errors).forEach(value => {
                if (value.isArray === true) {
                    value.forEach(function (msg) {
                        error = error + "\n" + msg;
                    });
                }
                else {
                    error = error + "\n" + value;
                }
            });
            this.text = error;
            this.color = "#F44336";
            this.snackbar = true;
        });
        this.snackbar = false;
    }
    getCustomers() {
        axios.get('/api/jobs/customer').then((response) => {
            if (response.data.data != null) {
                this.customer = response.data.data;
            }
            else {
                this.customer[0] = "test";
            }
        });
        return this.customer;
    }
    mounted() {
        if (this.$store.getters.isLoggedIn) {
            this.getMaterial();
            this.getThickness();
            this.getFormat();
            this.getWorktype();
            this.getCustomers();
            this.$store.state.monitor = false;
        }
        else {
            this.$store.commit('logout');
        }
    }
    getMaterial() {
        axios.get('/api/material').then((response) => {
            this.material = response.data.data;
        });
        return this.material;
    }
    getThickness() {
        axios.get('/api/thickness').then((response) => {
            this.thickness = response.data.data;
        });
        return this.thickness;
    }
    assigmentDelete(item) {
        if (confirm("Do you really want to delete?")) {
            let index = this.assignments.indexOf(item);
            if (index >= 0) {
                this.assignments.splice(index, 1);
                this.text = "Der Materialbedarf wurde erfolgreich gelöscht";
                this.color = "green";
                this.snackbar = true;
            }
            this.snackbar = false;
        }
    }
    worklogDelete(item) {
        if (confirm("Do you really want to delete?")) {
            let index = this.worklogs.indexOf(item);
            if (index >= 0) {
                this.worklogs.splice(index, 1);
                this.text = "Der Arbeitsschritt wurde erfolgreich gelöscht";
                this.color = "green";
                this.snackbar = true;
            }
            this.snackbar = false;
        }
        /*
        if (confirm("Do you really want to delete?")) {
            axios.delete('/api/assigment/' + id).then(
                () => {
                    this.getAssigment();
                    this.text = "Der Materialbedarf wurde erfolgreich gelöscht"
                    this.snackbar = true;
                }
            );
        }*/
    }
    getFormat() {
        axios.get('/api/format').then((response) => {
            this.format = response.data.data;
        });
        return this.format;
    }
    getWorktype() {
        axios.get('/api/worktype').then((response) => {
            this.worktype = response.data.data;
        });
        return this.worktype;
    }
    sendWorkflow() {
        if (this.workflow.id == null) {
            this.worklogs.push(this.workflow);
        }
        else {
            this.worklogs[this.workflow.id];
        }
        this.workflow = new Workflow();
        this.diaWork = false;
    }
    sendAssignments() {
        if (this.assignment.id == null) {
            this.assignments.push(this.assignment);
        }
        else {
            this.assignments[this.assignment.id];
        }
        this.assignment = new assignment();
        this.dia = false;
    }
    assigmentedit(item) {
        let index = this.assignments.indexOf(item);
        if (index >= 0) {
            this.assignment = this.assignments[index];
            this.assignment.id = index.toString();
            //this.worklogs.splice(index, 1);
            this.dia = true;
        }
    }
    worklogsedit(item) {
        let index = this.worklogs.indexOf(item);
        if (index >= 0) {
            this.workflow = this.worklogs[index];
            this.workflow.id = index.toString();
            //this.worklogs.splice(index, 1);
            this.diaWork = true;
        }
    }
    checkOrderNumber() {
        axios.get('/api/jobs/order/' + this.job.order_nr + '/' + this.job.article).then((response) => {
            if (response.status == 201) {
                this.text = " Die Bestellnummer " + this.job.order_nr + " mit dem Artikel " + this.job.article + " existieren schon";
                this.color = "#F44336";
                this.snackbar = true;
            }
        }).catch((error) => {
            // this.text = this.job.order_nr + " Die Bestellnummer ist verfügbar";
            // this.color="green";
            this.snackbar = false;
        });
        this.snackbar = false;
    }
    diaclose() {
        this.dia = false;
        this.diaWork = false;
    }
    printPDF(id) {
        let url = "http://" + window.location.hostname + "/jobs/" + id + "/pdf";
        window.open(url);
    }
};
CreateJob = __decorate([
    Component({
        name: "CreateJob",
    })
], CreateJob);
export default CreateJob;
